/* tslint:disable */
/* eslint-disable */
/**
 * Payment Schedule API
 * API to manage payment schedules (échéances de paiement)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Subscriber information linked to a payment schedule
 * @export
 * @interface PaymentScheduleSubscriberDto
 */
export interface PaymentScheduleSubscriberDto {
    /**
     * Unique identifier of the subscriber
     * @type {string}
     * @memberof PaymentScheduleSubscriberDto
     */
    id: string;
    /**
     * Last name of the subscriber
     * @type {string}
     * @memberof PaymentScheduleSubscriberDto
     */
    lastName?: string | null;
    /**
     * First name of the subscriber
     * @type {string}
     * @memberof PaymentScheduleSubscriberDto
     */
    firstName?: string | null;
    /**
     * Email address of the subscriber
     * @type {string}
     * @memberof PaymentScheduleSubscriberDto
     */
    email?: string | null;
    /**
     * Phone number of the subscriber
     * @type {string}
     * @memberof PaymentScheduleSubscriberDto
     */
    phone?: string | null;
    /**
     * Company name (for legal entities)
     * @type {string}
     * @memberof PaymentScheduleSubscriberDto
     */
    companyName?: string | null;
}

/**
 * Check if a given object implements the PaymentScheduleSubscriberDto interface.
 */
export function instanceOfPaymentScheduleSubscriberDto(value: object): value is PaymentScheduleSubscriberDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function PaymentScheduleSubscriberDtoFromJSON(json: any): PaymentScheduleSubscriberDto {
    return PaymentScheduleSubscriberDtoFromJSONTyped(json, false);
}

export function PaymentScheduleSubscriberDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentScheduleSubscriberDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'email': json['email'] == null ? undefined : json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'companyName': json['companyName'] == null ? undefined : json['companyName'],
    };
}

export function PaymentScheduleSubscriberDtoToJSON(json: any): PaymentScheduleSubscriberDto {
    return PaymentScheduleSubscriberDtoToJSONTyped(json, false);
}

export function PaymentScheduleSubscriberDtoToJSONTyped(value?: PaymentScheduleSubscriberDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'lastName': value['lastName'],
        'firstName': value['firstName'],
        'email': value['email'],
        'phone': value['phone'],
        'companyName': value['companyName'],
    };
}

